const PricingSection = () => (
  <section className="section dark">
    <h2 className="section-title">Plans</h2>

    <div className="pricing-grid">
      <div className="pricing-card">Basic<br/><span>Basic Signals Only</span></div>
      <div className="pricing-card highlight">Premium<br/><span>Premium Signals </span></div>
      <div className="pricing-card">SignalFlyPro<br/><span>Advanced Trade SetUp Options & Auto Execution</span></div>
    </div>
  </section>
);

export default PricingSection;

